import { render, staticRenderFns } from "./emailoem.vue?vue&type=template&id=c06dd7c6&"
import script from "./emailoem.vue?vue&type=script&lang=js&"
export * from "./emailoem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports